import {
  Shield,
  Database,
  Lock,
  UserCheck,
  Globe,
  Cookie,
  Mail,
} from "lucide-react";

import SiteFooter from "@/components/SiteFooter";
const sections = [
  {
    icon: Shield,
    title: "1. Introduction",
    content:
      "Printzee Media and Advertising Solutions FZE respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, and safeguard your information when you visit our website or use our services.",
  },
  {
    icon: Database,
    title: "2. Information We Collect",
    content:
      "We may collect personal information including your name, company name, email address, phone number, project requirements, billing details, and any files or artwork you submit. We may also collect technical information such as your IP address, browser type, device information, and website usage statistics.",
  },
  {
    icon: UserCheck,
    title: "3. How We Use Your Information",
    content:
      "Your information is used to provide quotations, process orders, communicate regarding projects, deliver requested services, improve our website, respond to inquiries, provide customer support, and comply with applicable legal obligations.",
  },
  {
    icon: Lock,
    title: "4. Data Security",
    content:
      "We implement appropriate administrative, technical, and organizational security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of internet transmission or electronic storage is completely secure.",
  },
  {
    icon: Globe,
    title: "5. Sharing of Information",
    content:
      "We do not sell, rent, or trade your personal information. Information may be shared with trusted service providers, payment processors, logistics partners, or legal authorities only when necessary to provide our services or comply with legal requirements.",
  },
  {
    icon: Cookie,
    title: "6. Cookies",
    content:
      "Our website may use cookies and similar technologies to improve website functionality, remember user preferences, analyze traffic, and enhance your browsing experience. You can manage cookie settings through your browser.",
  },
  {
    icon: Database,
    title: "7. Data Retention",
    content:
      "We retain personal information only for as long as necessary to fulfill the purposes described in this Privacy Policy, maintain business records, comply with legal obligations, and resolve disputes where applicable.",
  },
  {
    icon: UserCheck,
    title: "8. Your Rights",
    content:
      "Where permitted by applicable law, you may request access to your personal information, request corrections, request deletion where appropriate, or inquire about how your information is processed.",
  },
  {
    icon: Globe,
    title: "9. Third-Party Links",
    content:
      "Our website may contain links to external websites operated by third parties. We are not responsible for the privacy practices or content of those websites and encourage users to review their privacy policies.",
  },
  {
    icon: Shield,
    title: "10. Changes to This Policy",
    content:
      "We reserve the right to update this Privacy Policy at any time. Any changes will become effective immediately upon publication on this page. We encourage users to review this page periodically.",
  },
  {
    icon: Mail,
    title: "11. Contact Us",
    content:
      "If you have any questions regarding this Privacy Policy or the way we handle your personal information, please contact Printzee Media and Advertising Solutions FZE using the contact information provided on our website.",
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900 text-white py-24">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <span className="inline-block bg-white/10 backdrop-blur-md border border-white/20 px-5 py-2 rounded-full text-sm font-medium text-blue-200">
            Legal Information
          </span>

          <h1 className="text-5xl md:text-6xl font-bold mt-6">
            Privacy Policy
          </h1>

          <p className="max-w-3xl mx-auto mt-6 text-lg text-gray-300 leading-8">
            This Privacy Policy explains how{" "}
            <strong className="text-white">
              Printzee Media and Advertising Solutions FZE
            </strong>{" "}
            collects, uses, stores, and protects your personal information when
            you use our website or our branding, printing, signage, advertising,
            and event services.
          </p>

          <p className="mt-8 text-sm text-gray-400">
            Last Updated: July 2026
          </p>
        </div>
      </section>

      {/* Introduction */}
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="bg-white rounded-3xl shadow-sm border border-gray-200 p-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-5">
            Our Commitment to Privacy
          </h2>

          <p className="text-gray-600 leading-8">
            At Printzee Media and Advertising Solutions FZE, protecting your
            privacy is one of our priorities. Whether you request a quotation,
            place an order, contact our team, or browse our website, we are
            committed to handling your information responsibly and
            transparently.
          </p>
        </div>
      </section>

      {/* Sections */}
      <section className="max-w-6xl mx-auto px-6 pb-20">
        <div className="grid gap-8">
          {sections.map((item, index) => {
            const Icon = item.icon;

            return (
              <div
                key={index}
                className="bg-white rounded-3xl shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-200 p-8"
              >
                <div className="flex gap-5">
                  <div className="h-14 w-14 rounded-xl bg-blue-600 flex items-center justify-center text-white flex-shrink-0">
                    <Icon size={24} />
                  </div>

                  <div>
                    <h3 className="text-2xl font-semibold text-gray-900">
                      {item.title}
                    </h3>

                    <p className="mt-4 text-gray-600 leading-8">
                      {item.content}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
 <SiteFooter />
    </div>
  );
}